<script>
	import Router from "./router.svelte";
	import Nav from "./components/Nav.svelte";
	import Footer from "./components/Footer.svelte";
	import Login from "./pages/Login.svelte";
	import { menu, menuSub, menuSubSub, SERVER_LIST, tokenManager, serverTokens } from "./stores";

	$: accessToken = sessionStorage.getItem("AccessToken");

	// 현재 서버 정보
	$: currentServerInfo = (() => {
		const server = localStorage.getItem("selectedServer");
		return SERVER_LIST.find((s) => s.value === server) || SERVER_LIST[1]; // 기본값: Development
	})();

	// 로그인된 서버 목록
	$: loggedInServers = (() => {
		const tokens = $serverTokens;
		return SERVER_LIST.filter((server) => tokens[server.value]);
	})();

	// 서버 타입에 따른 로그아웃 텍스트
	$: logoutText = "모든 서버 로그아웃";

	// 서버 변경 핸들러
	function handleServerChange(event) {
		const newServer = event.target.value;
		const success = tokenManager.switchServer(newServer);

		if (success) {
			// 페이지 새로고침 없이 현재 상태 업데이트
			window.location.reload();
		} else {
			alert("해당 서버에 로그인되어 있지 않습니다.");
			// 드롭다운을 원래 값으로 되돌림
			event.target.value = localStorage.getItem("selectedServer");
		}
	}

	function fnNavOnOff() {
		const element = document.getElementById("layout-menu");
		const style = element.style.display;

		style === "flex" ? (element.style = "display:none") : (element.style = "display:flex");
	}

	// 컴포넌트 마운트 시 토큰 로드
	import { onMount } from "svelte";
	onMount(() => {
		tokenManager.loadAllTokens();
	});
</script>

{#if !accessToken}
	<Login />
{:else}
	<div class="layout-wrapper layout-content-navbar">
		<div class="layout-container">
			<Nav />
			<div class="layout-page">
				<div class="content-wrapper">
					<div class="container-xxl flex-grow-1 container-p-y">
						<div class="d-flex justify-content-between align-items-center">
							<h3 class="fw-bold py-2 mb-2">
								<button id="navBtn" class="bx bx-menu bx-sm" on:click={fnNavOnOff} style="border: none; background: none;" />

								<span class="text-muted fw-light">{$menu} / </span>{$menuSub}{$menuSubSub ? " / " + $menuSubSub : ""}
							</h3>

							<div class="d-flex align-items-center gap-3">
								<!-- 서버 선택 드롭다운 -->
								<div class="d-flex align-items-center">
									<select
										class="form-select form-select-sm"
										style="min-width: 150px; font-size: 0.85rem;"
										value={currentServerInfo.value}
										on:change={handleServerChange}
									>
										{#each loggedInServers as server}
											<option value={server.value}>
												{server.label}
												{#if server.value === currentServerInfo.value}
													(현재)
												{/if}
											</option>
										{/each}
									</select>
								</div>

								<!-- 로그아웃 버튼 -->
								<button
									class="btn btn-text-secondary btn-sm"
									on:click={() => {
										tokenManager.clearAllTokens();
										window.location = "/";
									}}
									style="opacity: 0.75; font-size: 0.85rem;"
								>
									<i class="bx bx-log-out me-1"></i>
									{logoutText}
								</button>
							</div>
						</div>
						<Router />
						<Footer />
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}
